import { render } from "./FaqQuestionForm.vue?vue&type=template&id=6b74d389&scoped=true"
import script from "./FaqQuestionForm.vue?vue&type=script&lang=js"
export * from "./FaqQuestionForm.vue?vue&type=script&lang=js"

import "./FaqQuestionForm.vue?vue&type=style&index=0&id=6b74d389&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b74d389"]])

export default __exports__